import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { AppLayoutComponent } from "./layout/app-layout/app-layout-component";
import { APP_LAYOUT_ROUTES } from './routes/app-layout.routes';
import { AuthGuard } from './auth.guard';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',  // Redirect to login if no route is matched
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('../app/views/login/login.module').then(m => m.LoginModule)
  },
  {
    path: '',
    canActivate: [AuthGuard], // Apply AuthGuard to this route and its children
    component: AppLayoutComponent,
    children: APP_LAYOUT_ROUTES
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {preloadingStrategy: PreloadAllModules
      ,  useHash: true
    })
    // RouterModule.forRoot(appRoutes, {
    //   useHash: true
    // })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}